<template>
  <div id="dashboard" class="row w-100 pl-5 justify-content-start" :style="{
    //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
    paddingRight: '0px',
    margin: '0px',
    padding: '0px !important',
  }">
    <div class="row pt-2 equal-cols" style="width: 120%">
      <div class="col-md-12">
        <section class="card mb-2">
          <!-- <header class="card-header bg-info text-white">
            <div class="card-actions"> <a href="#" class="card-action card-action-toggle" data-card-toggle=""></a> </div>
            <h2 class="card-title">GIS電子地圖</h2>
          </header> -->
          <!-- <div class="card-body" :style="{height: 500px}"> -->
          <div class="card-body" style=" height: max-content;">

            <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box" id="pills-tab" role="tablist">
              <li class="nav-item" role="presentation" v-for="(scenicArea, i) in myScenicAreaList" :key="i">
                <button :class="{'nav-link': true, 'active':(scenicArea.id === selectScenicAreaId) }" id="car-recognition-tab" data-bs-toggle="pill"
                  data-bs-target="#car-recognition" type="button" role="tab" aria-controls="car-recognition"
                  :aria-selected="(scenicArea.id === selectScenicAreaId)" @click="setScenicAreaId(scenicArea.id)"> {{ scenicArea.name }} </button>
              </li>
              <img v-if="!isMobileDevice" class="ms-auto" src="@/assets/img/fullScreen.png" style="cursor: pointer;" @click="fullScreen">
            </ul> 
            <div class="tab-content p-3 shadow-sm" id="pills-tabContent" style="display: block;">
              <div class="tab-pane fade  active show" id="car-recognition" role="tabpanel"
                aria-labelledby="car-recognition-tab">
                <div class="w-95 pl-5" ref="panel">
                  <div class="row w-100 justify-content-start" :style="{height: height}">
                    <matrix :groupData="streamings" :panelWidth='panelWidth' ></matrix>
                  </div>
                </div> 
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CONST from '../../utils/const'
import Utils from '../../utils/utils'
import Matrix from "../../components/Matrix.vue"
import MobileDetect from '../../utils/mobileDetect'
import Hls from 'hls.js';


export default {
  name: "Home",
  components: {
    Matrix
  },
  data() {
    return {
      divStyle: '',
      CONST: CONST,
      Utils: Utils,
      streamings: [],
      selectScenicAreaId: 14,
      panelWidth: null,
      resizeInterval: null,
      isMobileDevice: false,
      isHlsSupport: Hls.isSupported(),
      height: window.innerHeight > 900 ? 'calc(75vh)' : 'calc(150vh)',
      cardBodyHeight: '',
    };
  },

  computed: {
    ...mapState('scenicArea', { scenicAreaList: 'allscenicArea' }),
    ...mapGetters('scenicArea', {myScenicAreaList: 'getMyScenicArea'})

  },
  watch: {
    selectScenicAreaId() {
      this.setStreamings()
    },
    myScenicAreaList() {
      this.setDefaultSelectArea()

    },
    streamings() {
      this.isMobileDevice = MobileDetect.isMobileDevice()
      this.height= this.isMobileDevice ? 'calc('+(this.streamings.length)*280 +'px)' :    //'calc('+(this.streamings.length/5)*200 +'vh)' :
          this.streamings.length <= 2 ? 'calc(75vh)' : // 加路蘭只有兩台攝影機
          // this.streamings.length ==1 ? '600px':
          window.innerHeight > 900 ? 'calc(75vh)' : 'calc(150vh)';
      this.cardBodyHeight = this.isMobileDevice ? 'calc('+((this.streamings.length)*280+300) +'px)' : ''

      console.log("this.height ",this.height);
    }
  },
  methods: {
    setScenicAreaId(id) {
      this.selectScenicAreaId = parseInt(id);
    },
    async setStreamings() {
      this.streamings = []
      await this.$store.dispatch('scenicArea/getDeviceByScenicAreaId', { id: this.selectScenicAreaId })
      this.streamings = this.$store.getters['getScenicAreaVideoCamera'].filter(vc => vc.isDisabled === false)

    },

    fullScreen() {
      $('.matrix-board')[0].requestFullscreen()
    },

    getHeight() {
      return this.isMobileDevice ? 'calc('+(this.streamings.length)*280 +'px)' :    //'calc('+(this.streamings.length/5)*200 +'vh)' :
          this.streamings.length <= 2 ? 'calc(75vh)' : // 加路蘭只有兩台攝影機
          window.innerHeight > 900 ? 'calc(75vh)' : 'calc(150vh)';
    },

    handleResize() {
      this.height = this.getHeight();
      this.panelWidth = this.$refs.panel.clientWidth
      
    },

    setDefaultSelectArea() {
      if (this.myScenicAreaList.length < 1) {
        return
      }

      this.selectScenicAreaId = this.myScenicAreaList[0] ? this.myScenicAreaList[0].id : -1
      this.setStreamings()
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  async mounted() {
    this.setDefaultSelectArea();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
<style lang="scss" scoped>
//在site.css tabs 有長度限制
//site.css: 577  .tabbed [type="radio"]:nth-of-type(1):checked ~ .tabs .tab:nth-of-type(1) label

$max: 20;

@for $i from 1 through $max {
  .tabbed [type="radio"]:nth-of-type(#{$i}):checked~.tabs .tab:nth-of-type(#{$i}) label {
    background: #00ae9a !important;
    color: #fff;
  }

  .tabbed [type="radio"]:nth-of-type(#{$i}):checked~.tabs .tab:nth-of-type(#{$i}) label:after {
    -webkit-transform: scale(1);
    transform: scale(1);
  }


}


//site.css: 586 tabbed [type="radio"]:nth-of-type(1):checked ~ .tab-content:nth-of-type(1)
@for $i from 1 through $max {
  .tabbed [type="radio"]:nth-of-type(#{$i}):checked~.tab-content:nth-of-type(#{$i}) {
    display: block;
    box-shadow: none;
  }
}

.nav-tabs li .nav-link:hover {
  background-color: #00ae9a;
  color: #fff;
  border-bottom: 0.8px solid #EEE;
  border-top: 0.8px solid #EEE;

  // border:1px !important;
}
</style>